import AddIcon from "@mui/icons-material/Add";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { default as CancelIcon, default as CloseIcon } from "@mui/icons-material/Close";
import DeleteIcon from "@mui/icons-material/DeleteOutlined";
import EditIcon from "@mui/icons-material/Edit";
import SaveIcon from "@mui/icons-material/Save";
import Backdrop from "@mui/material/Backdrop";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import Fade from "@mui/material/Fade";
import Modal from "@mui/material/Modal";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";
import React, { useEffect, useState } from "react";
import "./Index.css";
import { Routes, Route, Navigate, useLocation, useHistory } from "react-router-dom";
import {
  Avatar,
  Badge,
  Card,
  CardContent,
  Checkbox,
  CircularProgress,
  FormControl,
  IconButton,
  InputAdornment,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select,
  TextField,
  Typography
} from "@mui/material";
import { styled } from "@mui/material/styles";
import {
  DataGrid,
  GridActionsCellItem,
  GridRowEditStopReasons,
  GridRowModes,
  GridToolbarContainer
} from "@mui/x-data-grid";
import axios from "axios";
import Swal from "sweetalert2";
import recipeDefaultImage from "../../assets/images/recipelogo/r2.jpg";
import uploadFileImage from "../../assets/images/logos/image.png";
import { difficultyLevel, nutritionalCategoryOptions } from "./RecipeResources";
import { set } from "date-fns";

const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1
});

const IngredientsDetailsModal = ({ open, onClose, details }) => {
  if (!details || details.length === 0) return null;
  console.log(details, "details");

  return (
    <Modal open={open} onClose={onClose}>
      <Box
        sx={{
          position: "absolute",
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
          width: 400,
          maxHeight: "80vh",
          bgcolor: "background.paper",
          boxShadow: 24,
          borderRadius: 4,
          overflow: "hidden",
          padding: 2
        }}
      >
        <Card sx={{ minWidth: 275 }}>
          <CardContent>
            {details.map((ingredient, index) => (
              <Typography key={index} component="div">
                {ingredient.quantity} {ingredient.unit} {ingredient.item}
              </Typography>
            ))}
          </CardContent>
        </Card>
      </Box>
    </Modal>
  );
};

const userType = 2;
const appColor = "#59D6DF";
const initialRows = [];
const apiBaseURL = process.env.REACT_APP_API_BASE_URL;
const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4
};

function EditToolbar(props) {
  const {
    setRows,
    setRowModesModel,
    addedUser,
    setAddedUser,
    showToolbar,
    setShowToolbar,
    selectedRecipe,
    setSelectedRecipe
  } = props;
  const [open, setOpen] = React.useState(false);
  const [id, setId] = useState("");
  const [image, setImage] = useState("");
  const [name, setName] = useState("");
  const [description, setDescription] = useState("");
  const [difficulty, setDifficulty] = useState("");
  const [ingredients, setIngredients] = useState([{ item: "", quantity: "", unit: "" }]);
  const [nutritionalCategory, setNutritionalCategory] = useState([]);

  const [nameError, setNameError] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [difficultyError, setDifficultyError] = useState("");
  const [ingredientError, setIngredientError] = useState("");
  const [imageError, setImageError] = useState("");
  const [nutritionError, setNutritionError] = useState("");
  const [isSubmitting, setIsSubmitting] = useState(false);

  const linkStart = selectedRecipe?.image?.indexOf("h");
  function getPosition(string, subString, index) {
    if (typeof string !== "string") return;
    return string.split(subString, index).join(subString).length;
  }
  const linkEnd = getPosition(selectedRecipe?.image, '"', 2);
  let link = "";
  if (linkStart && linkEnd) {
    for (let index = linkStart; index < linkEnd; index++) {
      // const char = selectedRecipe?.image[index];
      link += selectedRecipe?.image[index];
    }
  }
  const difficultyLevelOptions = [
    {
      value: 1,
      label: "Very easy"
    },
    {
      value: 2,
      label: "Easy"
    },
    {
      value: 3,
      label: "Medium"
    },
    {
      value: 4,
      label: "Hard"
    }
  ];
  const handleIngredientChange = (index, event) => {
    const { name, value } = event.target;
    const updatedIngredients = [...ingredients];
    updatedIngredients[index][name] = value;
    setIngredients(updatedIngredients);
  };

  const addIngredient = () => {
    setIngredients([...ingredients, { item: "", quantity: "", unit: "" }]);
  };

  const removeIngredient = (index) => {
    const updatedIngredients = ingredients.filter((_, i) => i !== index);
    setIngredients(updatedIngredients);
  };
  const ITEM_HEIGHT = 48;
  const ITEM_PADDING_TOP = 8;
  const MenuProps = {
    PaperProps: {
      style: {
        maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
        width: 250
      }
    }
  };

  const handleOpen = () => setOpen(true);

  const handleClose = () => {
    setOpen(false);
    setShowToolbar(false);
    setSelectedRecipe({});
    setDifficultyError("");
    setNameError("");
    setImageError("");
    setIngredientError("");
    setSelectedRecipe({});
  };

  const handleFileChange = (event) => {
    const file = event.target.files[0];
    if (file) {
      const acceptedTypes = ["png", "jpg", "jpeg"];
      const acceptedTypesLong = ["image/png", "image/jpg", "image/jpeg"];
      const nameExtension = file.name.split(".").pop();
      if (!acceptedTypes.includes(nameExtension) || !acceptedTypesLong.includes(file.type)) {
        setImageError("Please upload valid recipe image");
        return;
      } else {
        setImage(file);
        setImageError("");
      }
    }
  };

  function getKeyByValue(object, value) {
    return Object.keys(object).find((key) => object[key] === value);
  }
  useEffect(() => {
    if (Object.keys(selectedRecipe).length) {
      setId(selectedRecipe.id || "");
      setImage(selectedRecipe.image ? link : "");
      setName(selectedRecipe.name || "");
      setDescription(selectedRecipe.description || "");
      setDifficulty(getKeyByValue(difficultyLevel, `${selectedRecipe.difficultyLevel}`) || "");
      setIngredients(selectedRecipe.ingredients || [{ item: "", quantity: "", unit: "" }]);
      const selectedOptions =
        selectedRecipe?.nutritionalCategory &&
        Array.isArray(selectedRecipe?.nutritionalCategory) &&
        selectedRecipe?.nutritionalCategory.length
          ? nutritionalCategoryOptions
              .filter((value) => {
                if (selectedRecipe.nutritionalCategory.includes(value.label)) {
                  return true;
                }
              })
              .map((value) => {
                return value.value;
              })
          : [];
      setNutritionalCategory(selectedOptions);
    } else {
      setId("");
      setName("");
      setDescription("");
      setDifficulty("");
      setIngredients([{ item: "", quantity: "", unit: "" }]);
      setNutritionalCategory([]);
      setImage("");
      setDifficultyError("");
      setNameError("");
      setImageError("");
      setIngredientError("");
    }
    setOpen(showToolbar);
  }, [showToolbar, selectedRecipe]);

  const handleSubmit = (e) => {
    e.preventDefault();
    if (typeof image == "string" && image.trim() == "") {
      setImageError("Recipe image is required");
      return;
    }
    if (name.trim() == "") {
      setNameError("Recipe name is required");
      return;
    }
    if (difficulty == "") {
      setDifficultyError("Diffculty level is required");
      return;
    }

    if (
      ingredients.length === 0 ||
      ingredients.some((ing) => !ing.item || !ing.quantity || !ing.unit)
    ) {
      setIngredientError("All fields in Ingredient are required.");
      return;
    } else {
      setIngredientError("");
    }

    setIsSubmitting(true);
    const removedId = ingredients.map(function (item) {
      delete item._id;
      return item;
    });
    const getValueByNutritionId = nutritionalCategoryOptions
      .filter((value) => {
        if (nutritionalCategory.includes(+value.value)) {
          return true;
        }
      })
      .map((value) => {
        return value.label;
      });
    const formData = {
      id,
      image,
      name,
      description,
      difficulty: +difficulty,
      nutritionalCategory: getValueByNutritionId,
      ingredients: removedId
    };
    const headers = {
      "Content-Type": "multipart/form-data",
      "x-access-token": `${localStorage.getItem("token")}`
    };
    axios
      .post(`${apiBaseURL}/api/v1/admin/addupdaterecipe`, formData, {
        headers: headers
      })
      .then((res) => {
        if (res.data) {
          const { message } = res.data;
          setOpen(false);
          setShowToolbar(false);
          setAddedUser(!addedUser);
          Swal.fire({
            position: "center",
            icon: "success",
            title: `${message}`,
            showConfirmButton: false,
            timer: 1000
          });
          setImage("");
          setName("");
          setDescription("");
          setDifficulty("");
          setIngredients([{ item: "", quantity: "", unit: "" }]);
          setDifficultyError("");
          setNameError("");
          setImageError("");
          setSelectedRecipe({});
        }
      })
      .catch((error) => {
        // if (error.response.data.message == "Phone number already exists") {
        //   setPhoneNumberError("Phone number already exists!!");
        // } else if (error.response.data.message == "description already exists") {
        //   setdescriptionError("description already exists!!");
        // } else {
        //   setPhoneNumberError("");
        //   setdescriptionError("");
        // }
        console.log(error, "error");
      })
      .finally(() => {
        setIsSubmitting(false);
      });
  };

  const SmallAvatar = styled(Avatar)(({ theme }) => ({
    width: 22,
    height: 22,
    border: `2px solid ${theme.palette.background.paper}`
  }));

  return (
    <GridToolbarContainer sx={{ justifyContent: "flex-end" }}>
      <Button
        sx={{ color: "#59D6DF", border: "1px solid grey" }}
        startIcon={<AddIcon />}
        onClick={handleOpen}
      >
        Add Recipes
      </Button>
      <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={open}
        onClose={handleClose}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500
          }
        }}
      >
        <Fade in={open}>
          <Box sx={style}>
            <IconButton
              aria-label="close"
              onClick={handleClose}
              sx={(theme) => ({
                position: "absolute",
                right: 8,
                top: 12,
                color: theme.palette.grey[500]
              })}
            >
              <CloseIcon />
            </IconButton>
            <form autoComplete="off" onSubmit={handleSubmit}>
              <Box mb={2}>
                <Badge
                  overlap="circular"
                  anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
                  badgeContent={
                    <SmallAvatar
                      alt="Remy Sharp"
                      src={uploadFileImage}
                      onClick={() => document.getElementById("picture").click()}
                    />
                  }
                >
                  <Avatar
                    sx={{
                      width: "80px",
                      height: "80px",
                      boxShadow: "0px 5px 10px 0px #163F7533",
                      p: !image && 3
                    }}
                    alt="Recipe Picture"
                    src={image ? image : recipeDefaultImage}
                  />
                  <VisuallyHiddenInput
                    id="picture"
                    name="picture"
                    type="file"
                    accept="image/*"
                    onChange={handleFileChange}
                  />
                </Badge>
                <InputLabel sx={{ pt: 1, color: "red" }}>{imageError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Recipe Name"
                  value={name}
                  onChange={(e) => {
                    setName(e.target.value), setNameError("");
                  }}
                  sx={{ mt: 2 }}
                />
                <InputLabel sx={{ pt: 1, color: "red" }}>{nameError}</InputLabel>
              </Box>
              <Box mb={2}>
                <TextField
                  fullWidth
                  label="Recipe Description"
                  multiline
                  rows={6}
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  sx={{
                    mt: 2,
                    "& .MuiInputLabel-root": {
                      backgroundColor: "white",
                      padding: "4px"
                    },
                    "& .MuiInputBase-input": {
                      p: "0px !important"
                    },
                    "& .MuiInputBase-root": {
                      pt: "15px !important",
                      px: 2
                    }
                  }}
                />
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-simple-select-label">Difficulty level</InputLabel>
                  <Select
                    labelId="demo-simple-select-label"
                    fullWidth
                    value={difficulty}
                    onChange={(event) => {
                      setDifficulty(event.target.value);
                      setDifficultyError("");
                    }}
                    label="Difficulty level"
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                  >
                    {difficultyLevelOptions.map((option) => (
                      <MenuItem sx={{ height: "45px" }} key={option.value} value={option.value}>
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
                <InputLabel sx={{ pt: 1, color: "red" }}>{difficultyError}</InputLabel>
              </Box>
              <Box mb={2}>
                <FormControl fullWidth>
                  <InputLabel id="demo-multiple-checkbox-label">
                    Select Nutritional Category
                  </InputLabel>
                  <Select
                    labelId="demo-multiple-checkbox-label"
                    multiple
                    fullWidth
                    value={nutritionalCategory}
                    input={<OutlinedInput label="Select Nutritional Category" />}
                    onChange={(event) => {
                      setNutritionalCategory(event.target.value);
                    }}
                    renderValue={(selected) =>
                      selected
                        .map((value) => {
                          const option = nutritionalCategoryOptions.find(
                            (opt) => opt.value === value
                          );
                          return option ? option.label : value;
                        })
                        .join(", ")
                    }
                    sx={{ height: "45px" }}
                    endAdornment={
                      <InputAdornment
                        position="end"
                        sx={{
                          height: "100%",
                          alignItems: "center",
                          fontSize: "x-large",
                          pointerEvents: "none"
                        }}
                      >
                        <KeyboardArrowDownIcon />
                      </InputAdornment>
                    }
                    MenuProps={MenuProps}
                  >
                    {nutritionalCategoryOptions.map((option) => (
                      <MenuItem key={option.value} value={option.value}>
                        <Checkbox checked={nutritionalCategory.indexOf(option.value) > -1} />
                        {option.label}
                      </MenuItem>
                    ))}
                  </Select>
                </FormControl>
              </Box>
              <Box mb={2}>
                <Box sx={{ maxHeight: "30vh", overflowY: "auto" }}>
                  <Typography variant="h6">Ingredients</Typography>
                  {ingredients.map((ingredient, index) => (
                    <Box display="flex" gap={1} mb={1} key={index}>
                      <TextField
                        label="Item"
                        name="item"
                        value={ingredient.item}
                        onChange={(event) => handleIngredientChange(index, event)}
                        fullWidth
                      />
                      <TextField
                        label="Quantity"
                        name="quantity"
                        value={ingredient.quantity}
                        onChange={(event) => handleIngredientChange(index, event)}
                        fullWidth
                      />
                      <TextField
                        label="Unit"
                        name="unit"
                        value={ingredient.unit}
                        onChange={(event) => handleIngredientChange(index, event)}
                        fullWidth
                      />
                      <IconButton onClick={() => removeIngredient(index)} color="error">
                        <DeleteIcon />
                      </IconButton>
                    </Box>
                  ))}
                </Box>
                <Box mt={2}>
                  <Button onClick={addIngredient} variant="contained" sx={{ color: "#FFFFFF" }}>
                    Add More Ingredient
                  </Button>
                </Box>
                <InputLabel sx={{ pt: 1, color: "red" }}>{ingredientError}</InputLabel>
              </Box>
              <Box mt={4} mb={1}>
                <Button
                  variant="contained"
                  type="submit"
                  disabled={isSubmitting}
                  sx={{
                    backgroundColor: appColor,
                    color: "#FFFFFF",
                    ":hover": {
                      backgroundColor: appColor
                    }
                  }}
                  fullWidth
                >
                  {isSubmitting ? (
                    <CircularProgress size={20} color="inherit" />
                  ) : Object.keys(selectedRecipe).length ? (
                    "Update Recipe"
                  ) : (
                    "Register Recipe"
                  )}
                </Button>
              </Box>
            </form>
          </Box>
        </Fade>
      </Modal>
    </GridToolbarContainer>
  );
}

const Recipes = () => {
  const [rows, setRows] = React.useState(initialRows);
  const [addedUser, setAddedUser] = useState(false);
  const [rowModesModel, setRowModesModel] = React.useState({});
  const [selectedRecipe, setSelectedRecipe] = React.useState({});
  const [calledBlockUser, setCallBlockUser] = useState(false);
  const [profilePic, setProfilePic] = React.useState({});
  const [calledUpdateUser, setCallUpdateUser] = useState(false);
  const [searchBy, setSearchBy] = useState("");
  const [debouncedSearchBy, setDebouncedSearchBy] = useState("");
  const [modalOpen, setModalOpen] = useState(false);
  const [showToolbar, setShowToolbar] = React.useState(false);
  const [id, setId] = useState("");
  const [selectedIngredientsDetails, setSelectedIngredientsDetails] = useState(null);
  const { state } = useLocation();

  // Debounce search
  useEffect(() => {
    const timer = setTimeout(() => {
      setDebouncedSearchBy(searchBy);
    }, 500);

    return () => clearTimeout(timer);
  }, [searchBy]);

  // Reset pagination when search changes
  useEffect(() => {
    setPaginationModel((prev) => ({ ...prev, page: 0 }));
  }, [debouncedSearchBy]);

  // Pagination state
  const [paginationModel, setPaginationModel] = useState({
    page: 0,
    pageSize: 10
  });
  const [totalRows, setTotalRows] = useState(0);
  const [loading, setLoading] = useState(false);

  const handleOpenModal = (details) => {
    setSelectedIngredientsDetails(details);
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setSelectedIngredientsDetails(null);
    setModalOpen(false);
  };

  useEffect(() => {
    (async () => {
      setLoading(true);
      try {
        const headers = {
          "Content-Type": "application/json",
          "x-access-token": `${localStorage.getItem("token")}`
        };

        // Prepare request body with pagination and specific recipe ID if available
        const requestBody = {
          searchBy: debouncedSearchBy,
          page: paginationModel.page + 1, // API expects 1-based page numbers
          pageSize: paginationModel.pageSize
        };

        // Add specific recipe ID to request if available from state
        if (state?._id) {
          requestBody.specificRecipeId = state._id;
        }

        const recipeList = await axios.post(`${apiBaseURL}/api/v1/admin/getrecipes`, requestBody, {
          headers: headers
        });
        if (recipeList.data) {
          const { recipes, total, currentPage, totalPages } = recipeList.data.data;
          const currentRows = recipes.map((value, index) => {
            return {
              id: value?._id,
              image: value?.image
                ? `<img src="${value?.image}" height="50" width="50"> `
                : `<img src="${apiBaseURL}/img/Profile.svg" height="50"> `,
              name: `${value?.name} `,
              description: `${value?.description} `,
              difficultyLevel: difficultyLevel[`${value?.difficultyLevel}`],
              nutritionalCategory: value?.nutritionalCategory?.length
                ? value?.nutritionalCategory
                : null,
              ingredients: value?.ingredients.length ? value?.ingredients : null
            };
          });
          setRows(currentRows);
          setTotalRows(total || recipes.length);
          setShowToolbar(false);
        }
      } catch (error) {
        console.error("Error fetching recipes:", error);
        Swal.fire({
          icon: "error",
          title: "Error",
          text: "Failed to fetch recipes. Please try again."
        });
      } finally {
        setLoading(false);
      }
    })();
  }, [addedUser, debouncedSearchBy, paginationModel.page, paginationModel.pageSize, state?._id]);

  const handleRowEditStop = (params, event) => {
    if (params.reason === GridRowEditStopReasons.rowFocusOut) {
      event.defaultMuiPrevented = true;
    }
  };

  const handleDeleteClick = (id) => {
    Swal.fire({
      title: `Are you sure you want to delete this recipe?`,
      showCancelButton: true,
      confirmButtonText: "Yes",
      cancelButtonText: "No",
      confirmButtonColor: appColor
    })
      .then(async (result) => {
        if (result.isConfirmed) {
          try {
            const headers = {
              "Content-Type": "application/json",
              "x-access-token": `${localStorage.getItem("token")}`
            };
            const deleteRecipe = await axios.delete(`${apiBaseURL}/api/v1/admin/deleterecipe`, {
              headers: headers,
              data: {
                id
              }
            });
            if (deleteRecipe.data) {
              Swal.fire("The recipe is deleted now!", "", "success");
              setRows(rows.filter((row) => row.id !== id));
            }
          } catch (error) {
            console.log(error, "error");
          }
        } else if (result.isDenied) {
          Swal.fire("Changes are not saved", "", "info");
        }
      })
      .catch((error) => {
        console.log(error, "error");
      });
  };

  const handleRowModesModelChange = (newRowModesModel) => {
    setRowModesModel(newRowModesModel);
  };

  const handlePaginationModelChange = (newPaginationModel) => {
    setPaginationModel(newPaginationModel);
  };

  const handleFileChange = (e, params) => {
    const file = e.target.files[0];
    if (file) {
      const updatedRow = {
        ...params.row,
        // profilePic: `<img src="${URL.createObjectURL(file)}" />`,?
        profilePic: file
      };
      setProfilePic(updatedRow.profilePic);
      setRows((prevRows) => prevRows.map((row) => (row.id === params.id ? updatedRow : row)));
    }
  };

  const columns = [
    {
      field: "image",
      headerName: "Recipe Image",
      width: 150,
      editable: false,
      sortable: false,
      type: "file",
      renderCell: (params) => {
        return (
          <div
            dangerouslySetInnerHTML={{
              __html: params.value // Render the HTML content (image tag)
            }}
          />
        );
      },
      renderEditCell: (params) => {
        return (
          <Box>
            <VisuallyHiddenInput
              id="picture"
              name="picture"
              type="file"
              accept="image/*"
              onChange={(e) => handleFileChange(e, params)}
            />
            <IconButton
              aria-label="upload"
              sx={{
                border: "1px solid #F2F2F2",
                borderRadius: 2
              }}
              onClick={() => document.getElementById("picture").click()}
            >
              <img height="20" width="20" src={uploadFileImage} alt="upload icon" />
            </IconButton>
          </Box>
        );
      }
    },
    { field: "name", headerName: "Recipe Name", width: 250, editable: false, sortable: false },
    {
      field: "description",
      headerName: "Recipe Description",
      type: "string",
      width: 250,
      editable: false,
      sortable: false
    },
    {
      field: "difficultyLevel",
      headerName: "Difficulty Level",
      width: 150,
      editable: false,
      type: "singleSelect",
      valueOptions: ["very easy", "easy", "medium", "hard"],
      sortable: false
    },
    {
      field: "nutritionalCategory",
      headerName: "Nutritional Category",
      width: 250,
      editable: false,
      sortable: false,
      type: "singleSelect",
      valueOptions: [
        "Weight Loss",
        "Weight Gain",
        "High Protein",
        "Low Carb",
        "Vegan",
        "Vegetarian",
        "Breakfast",
        "Dinner",
        "Snacks",
        "Sides",
        "Drinks & Smoothies",
        "Lunch",
        "Dairy Free",
        "Gluten Free",
        "Dash",
        "Mediterranean"
      ]
    },
    {
      field: "ingredients",
      headerName: "Ingredients",
      sortable: false,
      width: 150,
      renderCell: (params) =>
        params.row.ingredients ? (
          <IconButton sx={{ left: -30 }} onClick={() => handleOpenModal(params.row.ingredients)}>
            <Button href="#text-buttons" style={{ textTransform: "none" }}>
              View Ingredients
            </Button>
          </IconButton>
        ) : (
          "N/A"
        )
    },
    {
      field: "actions",
      type: "actions",
      headerName: "Actions",
      width: 200,
      sortable: false,
      cellClassName: "actions",
      getActions: (params) => {
        const id = params.row.id;
        // const isInEditMode = rowModesModel[id]?.mode === GridRowModes.Edit;
        // if (isInEditMode) {
        //   return [
        //     <GridActionsCellItem
        //       icon={<SaveIcon />}
        //       label="Save"
        //       sx={{
        //         color: "primary.main"
        //       }}
        //       onClick={() => {
        //         handleSaveClick(id);
        //       }}
        //     />,
        //     <GridActionsCellItem
        //       icon={<CancelIcon />}
        //       label="Cancel"
        //       className="textPrimary"
        //       onClick={() => {
        //         handleCancelClick(id);
        //       }}
        //       color="inherit"
        //     />
        //   ];
        // }
        return [
          <GridActionsCellItem
            icon={<EditIcon />}
            label="Edit"
            className="textPrimary"
            onClick={() => {
              // handleEditClick(id);
              setShowToolbar(true);
              setSelectedRecipe(params.row);
            }}
            color="inherit"
          />,
          <GridActionsCellItem
            icon={<DeleteIcon />}
            label="Delete"
            onClick={() => {
              handleDeleteClick(id);
            }}
            color="inherit"
          />
        ];
      }
    }
  ];

  return (
    <DashboardLayout>
      <DashboardNavbar />
      <Box sx={{ width: "100%", marginBottom: 2 }}>
        <TextField
          id="outlined-basic"
          label="Search by Recipe Name"
          variant="outlined"
          value={searchBy}
          onChange={(event) => {
            setSearchBy(event.target.value);
          }}
          sx={{
            width: "300px"
          }}
        />
      </Box>
      <Box
        sx={{
          height: 675,
          width: "100%",
          "& .actions": {
            color: "text.secondary"
          },
          "& .textPrimary": {
            color: "text.primary"
          }
        }}
      >
        <DataGrid
          rows={rows}
          columns={columns}
          disableColumnResize
          disableColumnMenu
          editMode="row"
          rowModesModel={rowModesModel}
          onRowModesModelChange={handleRowModesModelChange}
          onRowEditStop={handleRowEditStop}
          slots={{
            toolbar: EditToolbar
          }}
          // Server-side pagination
          paginationMode="server"
          paginationModel={paginationModel}
          onPaginationModelChange={handlePaginationModelChange}
          rowCount={totalRows}
          pageSizeOptions={[10, 20, 30, 50]}
          loading={loading}
          sx={{
            fontFamily: `"Roboto","Helvetica","Arial",sans-serif`,
            fontWeight: 400,
            "& .MuiDataGrid-columnHeader": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-cell": {
              borderRight: "1px solid rgba(224, 224, 224, 1)"
            },
            "& .MuiDataGrid-row": {
              backgroundColor: "#fff",
              "&:nth-of-type(odd)": {
                backgroundColor: "#f9f9f9"
              }
            },
            "& .MuiDataGrid-cell:focus, & .MuiDataGrid-row:focus": {
              outline: "none"
            },
            "& .MuiDataGrid-cell:focus-within": {
              outline: "none"
            },
            "& .Mui-selected": {
              backgroundColor: "inherit !important"
            },
            "& .MuiDataGrid-columnHeader": {
              "& .MuiDataGrid-iconButtonContainer": {
                display: "none"
              },
              "& .MuiDataGrid-menuIcon": {
                display: "none"
              }
            }
          }}
          slotProps={{
            toolbar: {
              setRows,
              setRowModesModel,
              addedUser,
              setAddedUser,
              showToolbar,
              setShowToolbar,
              selectedRecipe,
              setSelectedRecipe
            }
          }}
        />
        <IngredientsDetailsModal
          open={modalOpen}
          onClose={handleCloseModal}
          details={selectedIngredientsDetails}
        />
      </Box>
    </DashboardLayout>
  );
};

export default Recipes;
